import { render } from "./CharacterSelection.vue?vue&type=template&id=4a6c8761&scoped=true"
import script from "./CharacterSelection.vue?vue&type=script&lang=js"
export * from "./CharacterSelection.vue?vue&type=script&lang=js"

import "./CharacterSelection.vue?vue&type=style&index=0&id=4a6c8761&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6c8761"]])

export default __exports__